<template>
  <div class="auth-card-wrapper">
    <div class="auth-card">
      <div class="auth-card-container">
        <img
          class="logo"
          alt="logo"
          src="@/assets/nubuilder.svg"
        />
        <h3 class="text-title mb-2">Confirm reset password</h3>
        <p class="reset-password-description">
          Requires a new registration code sent to you by email.
        </p>
      </div>

      <v-form ref="form" v-model="valid">
        <div class="auth-card-container form-fields" style="margin-bottom: 8px">
          <v-text-field
            label="Email"
            type="email"
            v-model="username"
            :rules="[rules.required, rules.email]"
            validate-on="blur"
            variant="outlined"
            density="default"
            ref="email"
          ></v-text-field>

          <v-text-field
            label="Registration code"
            type="text"
            v-model="code"
            :rules="[rules.required]"
            validate-on="blur"
            variant="outlined"
            density="default"
            ref="code"
          ></v-text-field>

          <v-text-field
            label="New password"
            v-model="pass"
            :append-inner-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append-inner="() => (e1 = !e1)"
            :type="e1 ? 'password' : 'text'"
            min="8"
            :rules="[rules.required]"
            hint="At least 8 characters, requires a mix of characters and numbers"
            counter
            validate-on="blur"
            variant="outlined"
            density="default"
            v-on:keydown.enter="submit"
          ></v-text-field>

          <v-row class="my-0">
            <v-col class="pa-0">
              <p class="bg-error" v-html="error"/>
              <p class="message" v-html="message"/>
            </v-col>
          </v-row>

          <div class="d-flex justify-center auth-card-container">
            <v-btn
              min-width="180px"
              rounded="lg"
              size="large"
              color="#363a40"
              class="d-flex"
              variant="flat"
              @click="submit"
            >
              Confirm Reset Password
            </v-btn>
          </div>

          <v-divider></v-divider>

          <div class="auth-card-footer-part">
            <div class="auth-card-footer">
              <p class="text">
                Go back to login?
                <router-link :to="{ path: '/login' }" tabindex="5">
                  <span class="light--text">Login</span>
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      code: '',
      pass: '',
      error: null,
      valid: true,
      message: null,
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      e1: true
    }
  },
  methods: {
    async submit (event) {
      event.preventDefault()
      const { valid } = await this.$refs.form.validate()
      if (valid) {
        this.$cognitoAuth.confirmPassword(this.username, this.code, this.pass, (err, result) => {
          if (err) {
            this.error = err.message
          } else {
            this.$router.replace({ path: '/login', query: { resetPasswordSuccess: true, username: this.username } })
          }
        })
      }
    }
  },
  created () {
    if (this.$route.query.username !== '') {
      this.username = this.$route.query.username
    }
  },
  mounted () {
    if (this.$route.query.username) {
      this.$refs.code.focus()
    } else {
      this.$refs.email.focus()
    }
  }
}
</script>

<style scoped>
.text {
  font-size: 13px;
  margin-bottom: 0;
  line-height: 14.3px;
}

.logo {
  width: 110px;
  height: 48px;
  margin-bottom: 24px;
}

.form-fields {
  gap: 12px;
  display: flex;
  flex-direction: column;
}

.message {
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
</style>
